import { create } from 'zustand';

import type {
  ModalFooterVariantType,
  ModalType,
} from '@/components/shared/ui/modals/types';

type ModalState = {
  modals: ModalType[];
  isModalOpen: boolean;
  modalFooterVariant: ModalFooterVariantType;
  openModal: (modalState: ModalType) => void;
  closeModal: (id: string) => void;
  setModalFooterVariant: (variant: ModalFooterVariantType) => void;
};

// 프로젝트 전체 모달
export const useModalStore = create<ModalState>((set) => ({
  modals: [],
  isModalOpen: false,
  modalFooterVariant: 'primary',
  openModal: (modalState) => {
    return set((state) => ({
      modals: [...state.modals, modalState],
      isModalOpen: true,
    }));
  },
  closeModal: (id) =>
    set((state) => {
      const newModals = state.modals.filter((modal) => modal.id !== id);
      return {
        modals: newModals,
        isModalOpen: newModals.length > 0,
      };
    }),
  setModalFooterVariant: (variant: ModalFooterVariantType) =>
    set({ modalFooterVariant: variant }),
}));
